import { combineReducers } from 'redux';
import editor from './editor';
import extensionGif from './extension-gif';
import extensionEmote from './extension-emote';
const rootReducers = {
    editor,
    extensionGif,
    extensionEmote
};
export default combineReducers(rootReducers);

//# sourceMappingURL=index.js.map